import React, { useState, useEffect } from "react";
import { PageTitle } from "../../components";
import {
  Table,
  Space,
  Button,
  Form,
  Input,
  Select,
  Modal,
  Tabs,
  message,
  Skeleton,
  Result,
} from "antd";
import type { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";

import { Routes, Route, useParams, Link, useNavigate } from "react-router-dom";
import { CURRENT_CLUB_ID } from "../../_helpers/constants";
import { usersApi } from "../../_helpers/apiService";

const { Option } = Select;
const { TabPane } = Tabs;

interface DataType {
  key?: string;
  lastName?: string;
  firstName?: string;
}

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

function Referee() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [data, setData] = useState<DataType>({});
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(true);

  let { refereeId } = useParams();

  useEffect(() => {
    if (refereeId) {
      fetchReferee();
    }
  }, [refereeId]);

  const fetchReferee = async () => {
    setLoading(true);
    try {
      const response = await usersApi.getById(parseInt(refereeId!));
      const userData = response.data;

      // Check if the user is a referee
      if (userData && userData.role === "referee") {
        setData({
          lastName: userData.last_name,
          firstName: userData.first_name,
        });
        form.setFieldsValue({
          email: userData.email,
          lastName: userData.last_name,
          firstName: userData.first_name,
          phoneNumber: userData.phone_number,
        });
        setHasAccess(true);
      } else {
        setHasAccess(false);
      }
    } catch (error: any) {
      console.error("Fetch referee error:", error);
      setHasAccess(false);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = () => {
    form
      .validateFields()
      .then(async (values) => {
        if (refereeId) {
          try {
            await usersApi.update(parseInt(refereeId), {
              email: values.email,
              first_name: values.firstName,
              last_name: values.lastName,
              phone_number: values.phoneNumber.startsWith('+976')
                ? values.phoneNumber
                : '+976' + values.phoneNumber,
            });

            message.success("Амжилттай.");
            fetchReferee(); // Refresh data
          } catch (error: any) {
            console.error("Update referee error:", error);
            message.error("Шүүгчийн мэдээлэл шинэчлэхэд алдаа гарлаа");
          }
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  if (loading) {
    return (
      <>
        <PageTitle loading={true} title="Уншиж байна..." right={null} />
        <div className="page-content-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <Skeleton loading={true} active />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (!hasAccess) {
    return (
      <>
        <PageTitle title="Хандах эрхгүй" right={null} />
        <div className="page-content-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <Result
                      status="403"
                      title="Хандах эрхгүй"
                      subTitle="Уучлаарай, шүүгчийн мэдээлэл олдсонгүй."
                      extra={
                        <Button type="primary" onClick={() => navigate("/referees")}>
                          Буцах
                        </Button>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {data ? (
        <PageTitle
          loading={loading}
          title={`${data?.lastName} ${data?.firstName}`}
          description={"Шүүгчийн профайл"}
          right={null}
          breadcrumbItems={[
            { link: "/referees", title: "Шүүгчид" },
            { title: `${data?.lastName} ${data?.firstName}` },
          ]}
        />
      ) : (
        ""
      )}
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <Skeleton loading={loading} active>
                    <Form {...formItemLayout} form={form} onFinish={onFinish}>
                      <Form.Item
                        label="Имэйл хаяг"
                        name="email"
                        rules={[
                          { required: true, message: "Имэйл хаяг оруулна уу!" },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Овог"
                        name="lastName"
                        rules={[
                          { required: true, message: "Овог оруулна уу!" },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Нэр"
                        name="firstName"
                        rules={[{ required: true, message: "Нэр оруулна уу!" }]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Утасны дугаар"
                        name="phoneNumber"
                        rules={[
                          {
                            required: true,
                            message: "Утасны дугаар оруулна уу!",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                          Хадгалах
                        </Button>
                      </Form.Item>
                    </Form>
                  </Skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Referee;
